import React, { useState, useEffect, useRef } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { isDefined } from 'class-validator';
import DraggableModal from 'src/app/components/DraggableModal/DraggableModal';
import styles from 'src/app/components/FMMAndPPMTabs/IncidentFolderAndWorkPackageTab/IncidentFolderAndWorkPackage.module.scss';
import { IncidentFolderDataType } from 'src/types/services/incident-folder-service.type';
import { useDispatch, useSelector } from 'react-redux';
import { contentsActions } from 'src/app/redux/actions';
import { incidentFolderService, logsService, workPackageService } from 'src/app/services';

import { reduxRootTypes } from 'src/types';
import { errorLocals } from 'src/locals';
import { attachmentHelper, statusHelper } from 'src/app/helpers';
import FileTable from '../../FileTable/fileTable';
import { FileTableType, IncidentFolderFormType } from './incidentFolderAndWorkPackageForm.config';
import { displaySuccessStatusMessage } from 'src/app/helpers/status.helper';
import { WorkPackageDataType } from 'src/types/services/ppm/work-package-service.type';
import { LogsData } from '../../Logs/logs.config';
import moment from 'moment';
import Logs from '../../Logs/Logs';

import { useTranslation } from 'react-i18next';
import getUsersOfEvent from 'src/app/helpers/getUsersOfEvent.helper';
import { generateFormNumber } from 'src/app/helpers/formNumberGenerator';
import { useUsers } from 'src/app/context/UserContext';
import { UserNamesTableResultType, UsersTableResultType } from 'src/types/services/user-service.type';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Button from 'antd/es/button';
import Select from 'antd/es/select';

const { TextArea } = Input;

const IncidentFolderForm: React.FC<IncidentFolderFormType> = ({
  setOnClickOpen,
  onClickOpen,
  setEditModal,
  incidentFolderFormAddData,
  workPackageFormAddData,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const fileInputRef = useRef<any>();

  const { eventName } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  const defaultIncidentFolderData = {
    id: '',
    eventId: '',
    incidentFolderNumber: '',
    incidentFolderName: '',
    incidentFolderManagerId: '',
    description: '',
    log: [],
    comment: '',
    attachments: [],
  };

  const defaultWorkPackageData = {
    id: '',
    eventId: '',
    workPackageNumber: '',
    workPackageName: '',
    workPackageManagerId: '',
    description: '',
    log: [],
    comment: '',
    attachments: [],
    projectId: '',
  };

  const [incidentFolderDataInForm, setIncidentFolderDataInForm] = useState<IncidentFolderDataType>(
    incidentFolderFormAddData || defaultIncidentFolderData,
  );
  const [workPackageDataInForm, setWorkPackageDataInForm] = useState<WorkPackageDataType>(
    workPackageFormAddData || defaultWorkPackageData,
  );
  const [addIncidentFolderModal, setAddIncidentFolderModal] = useState<boolean>(false);
  const [attachments, setAttachments] = useState<any[]>([]);
  const [deletedStringAttachments, setDeletedStringAttachments] = useState<string[]>([]);
  const [generatedAttachsForFileTable, setGeneratedAttachsForFileTable] = useState<FileTableType[]>([]);
  const { preferredLanguage } = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const { eventId } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  const [fieldsId, setFieldsId] = useState<any[]>([]);
  const [logsData, setLogsData] = useState<LogsData[]>([]);
  const [isSelectItemClicked, setIsSelectItemClicked] = useState<boolean>(false);

  const { fieldsList } = useSelector((state: reduxRootTypes.RootStateType) => state.fieldsState);
  const { projectsList } = useSelector((state: reduxRootTypes.RootStateType) => state.projectsState);
  const { incidentFolderList } = useSelector((state: reduxRootTypes.RootStateType) => state.incidentFolderState);

  const { usersList } = useUsers();

  type CombinedKeys = keyof IncidentFolderDataType | keyof WorkPackageDataType;

  const onFormChange = (inputLabel: CombinedKeys, value: any) => {
    if (incidentFolderFormAddData) {
      setIncidentFolderDataInForm({ ...incidentFolderDataInForm, [inputLabel]: value });
    } else if (workPackageFormAddData) {
      setWorkPackageDataInForm({ ...workPackageDataInForm, [inputLabel]: value });
    }
  };

  useEffect(() => {
    if (!incidentFolderFormAddData) return;

    const relatedIncident = incidentFolderList.find((i) => i.id === incidentFolderFormAddData.id);

    if (relatedIncident) {
      setIncidentFolderDataInForm(relatedIncident);

      form.setFieldsValue(relatedIncident);
    }
  }, [incidentFolderList]);

  useEffect(() => {
    if (
      incidentFolderFormAddData &&
      incidentFolderFormAddData.attachments &&
      incidentFolderFormAddData?.attachments.length !== 0
    ) {
      setAttachments([...incidentFolderFormAddData?.attachments]);
    } else if (
      workPackageFormAddData &&
      workPackageFormAddData.attachments &&
      workPackageFormAddData?.attachments.length !== 0
    ) {
      setAttachments([...workPackageFormAddData?.attachments]);
    }
  }, [incidentFolderFormAddData, workPackageFormAddData]);

  useEffect(() => {
    if (incidentFolderFormAddData) {
      if (
        incidentFolderDataInForm &&
        incidentFolderDataInForm.attachments !== undefined
        // incidentFolderDataInForm?.attachments.length !== 0
      ) {
        setIncidentFolderDataInForm({ ...incidentFolderDataInForm, attachments });
      }
    } else if (workPackageFormAddData) {
      if (
        workPackageDataInForm &&
        workPackageDataInForm.attachments !== undefined
        // workPackageDataInForm?.attachments.length !== 0
      ) {
        setWorkPackageDataInForm({ ...workPackageDataInForm, attachments });
      }
    }
  }, [attachments]);

  useEffect(() => {
    if (incidentFolderFormAddData) {
      let incidentForFieldId = [];
      if (fieldsList) {
        incidentForFieldId = fieldsList.filter(
          (obj) => obj.fieldsType === 2 && obj.id === incidentFolderFormAddData?.id,
        );
        incidentForFieldId = incidentForFieldId.map((e) => e.id);
        setFieldsId(incidentForFieldId);
      }
    } else if (workPackageFormAddData) {
      let workPackageForFieldId = [];
      if (fieldsList) {
        workPackageForFieldId = fieldsList.filter(
          (obj) => obj.fieldsType === 18 && obj.id === workPackageFormAddData?.id,
        );
        workPackageForFieldId = workPackageForFieldId.map((e) => e.id);
        setFieldsId(workPackageForFieldId);
      }
    }
  }, [fieldsList]);

  const getLogsData = async () => {
    try {
      const logData = await logsService.lookupLogs({
        fieldIds: fieldsId.length > 0 ? fieldsId : undefined,
        blockSpinner: true,
      });

      const tempLog: LogsData[] = [];
      logData.data.rows.forEach((obj, index) => {
        const detail = obj.description;

        const match = detail.match(/has been\s+(\w+)/i);
        const actionWord = match?.[1]?.toLowerCase();

        const action =
          actionWord === 'created'
            ? 'CREATE'
            : actionWord === 'updated'
            ? 'UPDATE'
            : actionWord === 'deleted'
            ? 'DELETE'
            : 'Unknown';

        const username = usersList.find((e) => e.id === obj.createdById)?.userName || '-';

        tempLog.push({
          key: index,
          user: username,
          action,
          details: detail,
          timestamp: moment(obj.createdAt).format('HH:mm DD/MM/YYYY'),
        });
      });

      setLogsData(tempLog);

      // dispatch(contentsActions.incidentFolderList(incidentFolderData.data.rows));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (fieldsId.length > 0) {
      getLogsData();
    }
  }, [fieldsId, incidentFolderList]);

  const onFormSave = async () => {
    if (setEditModal) {
      try {
        if (incidentFolderFormAddData) {
          const incidentFolderUpdateData = await incidentFolderService.incidentFolderEdit(
            incidentFolderDataInForm,
            deletedStringAttachments,
          );
          setAddIncidentFolderModal(false);
          setIncidentFolderDataInForm(defaultIncidentFolderData);

          dispatch(
            contentsActions.incidentFolderEdited({
              ...incidentFolderUpdateData.data,
              incidentFolderManagerId: incidentFolderUpdateData.data.incidentFolderManagerId || undefined,
            }),
          );
          displaySuccessStatusMessage(t('success.edited'));
          setOnClickOpen(false);
        } else if (workPackageFormAddData) {
          const workPackageUpdateData = await workPackageService.workPackageEdit(
            workPackageDataInForm,
            deletedStringAttachments,
          );
          setAddIncidentFolderModal(false);
          setWorkPackageDataInForm(defaultWorkPackageData);

          dispatch(
            contentsActions.workPackageEdited({
              ...workPackageUpdateData.data,
              workPackageManagerId: workPackageUpdateData.data.workPackageManagerId || undefined,
            }),
          );
          displaySuccessStatusMessage(t('success.edited'));
          setOnClickOpen(false);
        }
      } catch (error: any) {
        if (error !== errorLocals.errorHandledError) {
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    } else {
      try {
        if (incidentFolderFormAddData) {
          const incidentFolderAddData = await incidentFolderService.incidentFolderAdd(incidentFolderDataInForm, {
            blockErrorHandler: true,
          });
          setAddIncidentFolderModal(false);
          setIncidentFolderDataInForm(defaultIncidentFolderData);
          dispatch(contentsActions.fieldListAdd({ id: incidentFolderAddData.data.id, fieldsType: 2 }));
          dispatch(contentsActions.incidentFolderAdded(incidentFolderAddData.data));
        } else if (workPackageFormAddData) {
          const workPackageAddData = await workPackageService.workPackageAdd(workPackageDataInForm, {
            blockErrorHandler: true,
          });
          setAddIncidentFolderModal(false);
          setWorkPackageDataInForm(defaultWorkPackageData);
          dispatch(contentsActions.fieldListAdd({ id: workPackageAddData.data.id, fieldsType: 18 }));
          dispatch(contentsActions.workPackageAdded(workPackageAddData.data));
        }
        displaySuccessStatusMessage(t('success.added'));
        setOnClickOpen(false);
      } catch (error) {
        if (error !== errorLocals.errorHandledError) {
          // @ts-ignore
          statusHelper.displayErrorMessage(error.response.data.message);
        }
      }
    }
  };
  useEffect(() => {
    const tempArray: any[] = [];
    if (attachments === null) {
      setAttachments([]);
    } else {
      attachments?.forEach((element: any) => {
        tempArray.push(element);
      });
      setGeneratedAttachsForFileTable(tempArray);
    }
  }, [attachments]);

  useEffect(() => {
    if (onClickOpen && !setEditModal && incidentFolderFormAddData) {
      const generatedNumber = generateFormNumber(incidentFolderList, 'incidentFolderNumber');

      setIncidentFolderDataInForm({
        ...incidentFolderDataInForm,
        incidentFolderNumber: generatedNumber,
      });

      form.setFieldsValue({
        incidentFolderNumber: generatedNumber,
      });
    }
  }, [onClickOpen, setEditModal, incidentFolderFormAddData]);

  const handleOnChangeUploadInput = async (
    onChangeInputEvent: React.ChangeEvent<HTMLInputElement>,
    index: number | undefined = undefined,
  ) => {
    const getUploadInput = await attachmentHelper.handleOnChangeUploadInput(
      onChangeInputEvent,
      index,
      attachments,
      preferredLanguage,
      t,
    );

    if (getUploadInput?.newImages) {
      setAttachments(getUploadInput.newImages);
    }
    // setReplacedImageIndexes([...replacedImageIndexes, ...getUploadInput?.currentReplacedIndexes]);
  };

  const deleteAttachment = (attachment: any) => {
    if (isDefined(attachment.url)) {
      setAttachments(attachments.filter((atth: any) => atth !== attachment));
    } else {
      setAttachments(attachments.filter((atth: any) => atth !== attachment));
      setDeletedStringAttachments([...deletedStringAttachments, attachment.path]);
    }
  };

  return (
    <>
      {onClickOpen && (
        <DraggableModal
          headerText={
            incidentFolderFormAddData
              ? setEditModal
                ? `${t('FMM.incidentFolder.editIncidentFolder')} (${incidentFolderDataInForm.incidentFolderName})`
                : `${t('FMM.incidentFolder.addIncidentFolder')} (${incidentFolderDataInForm.incidentFolderName})`
              : setEditModal
              ? t('PPM.workPackage.editWorkPackage')
              : t('PPM.workPackage.addWorkPackage')
          }
          onClickClose={() => setOnClickOpen(false)}
          style={{ width: '800px', height: '600px' }}
        >
          <Form
            initialValues={incidentFolderFormAddData ? incidentFolderDataInForm : workPackageDataInForm}
            scrollToFirstError={{ behavior: 'smooth' }}
            onFinish={onFormSave}
            form={form}
          >
            <div className="popup-main-container">
              <div className="popup-container">
                <div className="popup-content" style={{ padding: 0 }}>
                  <div className={styles.container} style={{ padding: 10, marginRight: 15 }}>
                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-input-container-private">
                        <span className="popup-input-title">{t('general.event')}</span>
                        <Input className={styles.standard_input} value={eventName} disabled />
                      </div>
                      <div className="popup-input-container-private">
                        {incidentFolderFormAddData ? (
                          <>
                            <span className="popup-input-title">{t('FMM.incidentFolder.incidentFolderManagerId')}</span>
                            <Form.Item
                              name="incidentFolderManagerId"
                              rules={[{ required: true, message: t('general.required') || '' }]}
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                className={styles.standard_input}
                                value={incidentFolderDataInForm.incidentFolderManagerId || undefined}
                                onChange={(e) => onFormChange('incidentFolderManagerId', e)}
                                onClick={() => setIsSelectItemClicked(true)}
                              >
                                {incidentFolderDataInForm.incidentFolderManagerId == null && !isSelectItemClicked && (
                                  <Select.Option value={undefined} disabled>
                                    <p style={{ color: 'gray' }}>{t('general.deletedUser')}</p>
                                  </Select.Option>
                                )}
                                {getUsersOfEvent(usersList, eventId).map(
                                  (user: UserNamesTableResultType | UsersTableResultType) => (
                                    <Select.Option key={user.id} value={user.id}>
                                      {user.userName}
                                    </Select.Option>
                                  ),
                                )}
                              </Select>
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            <span className="popup-input-title">{t('PPM.workPackage.workPackageManager')}</span>
                            <Form.Item
                              name="workPackageManagerId"
                              rules={[{ required: true, message: t('general.required') || '' }]}
                            >
                              <Select
                                className={styles.standard_input}
                                value={workPackageDataInForm.workPackageManagerId || undefined}
                                onChange={(e) => onFormChange('workPackageManagerId', e)}
                                onClick={() => setIsSelectItemClicked(true)}
                              >
                                {workPackageDataInForm.workPackageManagerId == null && !isSelectItemClicked && (
                                  <Select.Option value={null} disabled>
                                    <span style={{ color: 'gray' }}>{t('general.deletedUser')}</span>
                                  </Select.Option>
                                )}

                                {usersList
                                  .filter((user) => user.userName.toLowerCase() !== 'Root'.toLowerCase())
                                  .map((user) => (
                                    <Select.Option key={user.id} value={user.id}>
                                      {user.userName}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </>
                        )}
                      </div>
                    </div>
                    {workPackageFormAddData && (
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('PPM.projects.project')}</span>
                        <Form.Item name="projectId" rules={[{ required: true, message: t('general.required') || '' }]}>
                          <Select
                            className={styles.standard_input}
                            value={workPackageDataInForm.projectId || undefined}
                            onChange={(e) => onFormChange('projectId', e)}
                          >
                            {projectsList.map((project) => (
                              <Select.Option key={project.id} value={project.id}>
                                {project.shortName}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    )}
                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-input-container-private">
                        {incidentFolderFormAddData ? (
                          <>
                            <span className="popup-input-title">{t('FMM.incidentFolder.incidentFolderNumber')}</span>
                            <Form.Item
                              name="incidentFolderNumber"
                              rules={[{ required: true, message: t('general.required') || '' }]}
                            >
                              <Input
                                className={styles.standard_input}
                                value={incidentFolderDataInForm.incidentFolderNumber}
                                onChange={(e) => onFormChange('incidentFolderNumber', e.target.value)}
                              />
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            <span className="popup-input-title">{t('PPM.workPackage.workPackageNumber')}</span>
                            <Form.Item
                              name="workPackageNumber"
                              rules={[{ required: true, message: t('general.required') || '' }]}
                            >
                              <Input
                                className={styles.standard_input}
                                value={workPackageDataInForm.workPackageNumber}
                                onChange={(e) => onFormChange('workPackageNumber', e.target.value)}
                              />
                            </Form.Item>
                          </>
                        )}
                      </div>
                      <div className="popup-input-container-private">
                        {incidentFolderFormAddData ? (
                          <>
                            <span className="popup-input-title">{t('FMM.incidentFolder.incidentFolderName')}</span>
                            <Form.Item
                              name="incidentFolderName"
                              rules={[{ required: true, message: t('general.required') || '' }]}
                            >
                              <Input
                                className={styles.standard_input}
                                value={incidentFolderDataInForm.incidentFolderName}
                                onChange={(e) => onFormChange('incidentFolderName', e.target.value)}
                              />
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            <span className="popup-input-title">{t('PPM.workPackage.workPackageName')}</span>
                            <Form.Item
                              name="workPackageName"
                              rules={[{ required: true, message: t('general.required') || '' }]}
                            >
                              <Input
                                className={styles.standard_input}
                                value={workPackageDataInForm.workPackageName}
                                onChange={(e) => onFormChange('workPackageName', e.target.value)}
                              />
                            </Form.Item>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.description')}</span>
                      <Form.Item name="description" rules={[{ required: false, message: t('general.required') || '' }]}>
                        <TextArea
                          rows={4}
                          showCount
                          maxLength={2048}
                          value={
                            incidentFolderFormAddData
                              ? incidentFolderDataInForm.description
                              : workPackageDataInForm.description
                          }
                          onChange={(e) => onFormChange('description', e.target.value)}
                        />
                      </Form.Item>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.log')}</span>
                      <Form.Item name="log">
                        <Logs logsData={logsData} />
                      </Form.Item>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.comment')}</span>
                      <Form.Item name="comment" rules={[{ required: false, message: t('general.required') || '' }]}>
                        <TextArea
                          rows={3}
                          showCount
                          maxLength={256}
                          value={
                            incidentFolderFormAddData ? incidentFolderDataInForm.comment : workPackageDataInForm.comment
                          }
                          onChange={(e) => onFormChange('comment', e.target.value)}
                        />
                      </Form.Item>
                    </div>

                    <div className={styles.attachmentsTitle}>
                      <Form.Item name="attachment" rules={[{ required: false, message: t('general.required') || '' }]}>
                        <Button
                          className="attachment"
                          onClick={() => fileInputRef.current.click()}
                          disabled={attachments?.length > 2}
                          type="primary"
                          icon={<UploadOutlined style={{ marginRight: '5px' }} />}
                        >
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={(e) => handleOnChangeUploadInput(e)}
                          />
                          {t('general.addAttachment')}
                        </Button>
                      </Form.Item>
                    </div>
                    <FileTable
                      dataSrc={generatedAttachsForFileTable}
                      deleteRow={deleteAttachment}
                      attachments={attachments}
                      // editRow={incidentFolderDataInForm.attachments}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="popup-footer" style={{ marginRight: '7%', marginTop: '2%' }}>
              <div>
                <button className="next-button" type="submit">
                  {t('general.save')}
                </button>
                <button className="modal-button" onClick={() => setOnClickOpen(false)} type="button">
                  {t('general.cancel')}
                </button>
              </div>
            </div>
          </Form>
        </DraggableModal>
      )}
    </>
  );
};

export default IncidentFolderForm;
